import { connect } from 'react-redux'
import ActivateModeComponent from './component'

const mapStateToProps = (state) => ({})
const mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(ActivateModeComponent)